import React, { Suspense, useMemo } from 'react'
import { Table as InternalTable } from '@imcva/reactstrap-table'
import Card from 'src/components/Card'
import { Eeocs } from 'src/queries'
import useToggleStateValue from 'src/hooks/useToggleStateValue'
import CardBody from './CardBody'
import DocumentData from './DocumentData'
import Viewer from './Viewer'
import { columns } from './columns'
import useFilterState from './Filters/useFilterState'
import Filters from './Filters'
import { Button } from 'reactstrap'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

const Table: React.FC = (props) => {
  const viewer = useToggleStateValue<string | undefined>(undefined)
  const documentData = useToggleStateValue<Eeocs[0] | undefined>(undefined)
  const { filterProps, queryFilters, buttonColor } = useFilterState()
  const handleOpenFilters = filterProps.toggleOpen
  const memoColumns = useMemo(() => {
    return columns({
      toggleViewer: viewer.toggle,
      toggleData: documentData.toggle
    })
  }, [viewer.toggle, documentData.toggle])
  return (
    <>
      <Card
        title='EEOC Paperwork'
        primaryAction={[
          {
            key: 'position-filters',
            tag: Button,
            icon: faFilter,
            text: 'Filter',
            onClick: handleOpenFilters,
            color: buttonColor
          }
        ]}
      >
        <Suspense fallback={<InternalTable options={{ data: [], columns: memoColumns }} suspend={3} />}>
          <CardBody columns={memoColumns} queryFilters={queryFilters} />
        </Suspense>
      </Card>
      <Viewer id={viewer.value} isOpen={viewer.hasState} toggle={viewer.toggle} />
      <DocumentData
        data={documentData.value}
        isOpen={documentData.hasState}
        toggle={documentData.toggle}
      />
      <Filters {...filterProps} />
    </>
  )
}

export default Table
